import { render, staticRenderFns } from "./promoted-channel-table.vue?vue&type=template&id=0646be09&scoped=true"
import script from "./promoted-channel-table.vue?vue&type=script&lang=js"
export * from "./promoted-channel-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0646be09",
  null
  
)

export default component.exports